exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-enter-active, .alert-leave-active {\n    transition: opacity .4s;\n}\n", ""]);

// exports
